export default __webpack_public_path__ + "static/media/rnr-sports-table-13-cn.d4119239.webp";